import { List } from '@mui/material';
import React, { useMemo } from 'react';
import { useAccess } from '../../../../providers';
import logo from '../../../../static/images/gp.png';
import { SideMenuItemModel } from '../../models';
import ListItemLink, { ListItemLinkProps } from './ListItemLink';
import { useStyles } from './MenuList.styles';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

interface IMenuList {
  menu: SideMenuItemModel[];
  showItemTooltip?: boolean;
  onDrawerOpen: any;
  onDrawerClose: any;
  onSubMenuDrawerOpen: any;
  handleSubMenuOpenHandle: any;
}

export const MenuList = (props: IMenuList) => {
  const { menu, showItemTooltip, onDrawerOpen, onDrawerClose, onSubMenuDrawerOpen, handleSubMenuOpenHandle } = props;
  const { classes } = useStyles();

  const { checkPathAccess } = useAccess();

  const menuToRender = useMemo(
    () =>
      menu
        .map((item: SideMenuItemModel) => {
          if (!checkPathAccess(item.to)) {
            return undefined;
          } else {
            if (item.children?.length > 0) {
              item.children = item.children.filter((child: SideMenuItemModel) =>
                checkPathAccess(child.to),
              );
              item.children = item.children.length ? item.children : undefined;
            }
            return item;
          }
        })
        .filter(Boolean),
    [checkPathAccess, menu],
  );

  return (
    <>
      <List>
        <ListItem className={classes.logoItem}>
          <div className={classes.logoBox}>
            <img src={logo} alt="logo" />
          </div>
          <ListItemButton>
            <ListItemText sx={{ paddingLeft: 2, color: '#231F20'}}><b className={classes.logoText}>Real Time Routing</b></ListItemText>
          </ListItemButton>
        </ListItem>
        {(menuToRender as SideMenuItemModel[]).map(
          ({
            text,
            validPathName,
            children,
            routePrefixMatch,
            ...rest
          }: SideMenuItemModel) => {
            const itemProps: ListItemLinkProps = {
              ...rest,
              validPathName,
              primary: text,
              showItemTooltip,
              subMenu: children,
              onDrawerClose : onDrawerClose,
              onDrawerOpen : onDrawerOpen,
              onSubMenuDrawerOpen : onSubMenuDrawerOpen,
              handleSubMenuOpenHandle : handleSubMenuOpenHandle,
            };

            return <ListItemLink key={text} {...itemProps} />;
          },
        )}
      </List>
    </>
  );
};
